/**
 * Состояния отчет дла риелтора:
 *  default - формирование отчета, все фильтры работают
 *  preview - предпросмотр, фильтры залочены, можно писать комментарии
 *  share - отчет сформирован, доступна кнопка шаринга
 *  finished - фильтры залочены, ничего изменять нельзя (открыли отчет по ссылке)
 */
export enum EReportStatus {
  Default = 'default',
  Preview = 'preview',
  Share = 'share',
  Finished = 'finished',
}

export const SEND_REPORT_BLOCK_ID = 'send_report_to_customer_block';
